import React from 'react'
import Select from 'react-select';

// PROPS
// Options=
// [
//   { value: 'chocolate', label: 'Chocolate' },
// ]
// borderStyle='hidden'

import {
  presenceErrorClass,
} from 'servos/formValidations'

class SelectInput extends React.Component {
  onChange = (selected) => {
    this.props.onChange(selected.value)
  }

  selectedOption = () => {
    const {
      options,
      defaultValue,
  } = this.props

    if (defaultValue) {
      return options.filter(option => option.value == defaultValue)
    } else {
      return ''
    }
  }

  render() {
    let {
      errorMessage,
      options,
      borderStyle,
    } = this.props


    return(
      <div className='input-group'>
        <Select
          styles={ selectStyles(getBorderStyle(borderStyle)) }
          value={ this.selectedOption() }
          onChange={ this.onChange }
          className={`form-control-react-select ${presenceErrorClass(errorMessage)}`}
          options={ this.props.options }
          placeholder={ 'Select' }
        />
        <div className="invalid-feedback">
          { errorMessage }
        </div>
      </div>
    )
  }
}

const getBorderStyle = (option) => {
  switch(option) {
    case 'responsive':
      return bordersStyle.responsive
    case 'hidden':
      return bordersStyle.hidden
    default:
      return bordersStyle.default
  }
}

const bordersStyle = {
  default: {
    border: '1px solid #C5C6C7',
    borderColor: '#C5C6C7',
  },
  responsive: {
    "@media only screen and (min-width: 576px)": {
      border: '1px solid #C5C6C7',
      borderColor: '#C5C6C7',
    },
    "@media (min-width: 577px)": {
      border: 'none',
    }
  },
  hidden: {
    border: 'none',
  }
}

const selectStyles = (borderOptions) => ({
  container: (provided, state) => ({
    ...provided,
    ...(borderOptions),
    width: '100%',
    boxShadow: 'none',
  }),
  control: (provided, state) => ({
    ...provided,
    border: 'none',
    boxShadow: 'none',
    "&:active": {
      border: 'none',
      boxShadow: 'none',
    },
    "&:hover": {
      border: 'none',
      boxShadow: 'none',
    }
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#10c98f' : (state.isFocused ? '#F3FCF9' : '#fff'),
    "&:active": {
      backgroundColor: '#F3FCF9'
    }
  })
})

export default SelectInput;
